/**
 * Shared popup configuration for every enriched finder drop-down.
 *
 * Kendo defaults the popup height to 200px, which was sized for single-line rows; the
 * panels are two to three lines, so 320px restores roughly the previous item count.
 * The width is deliberately not set here — Kendo applies the host element's width inline,
 * and `.finder-popup { min-width: ... }` in _finder.scss overrides that by cascade without
 * pinning every finder to one fixed width.
 */
export const FINDER_POPUP = {
    className: 'finder-popup',
    height: '320px',
    // Matches Kendo's own default (Popup.mjs:36) rather than changing it — stated explicitly so
    // the viewport-fitting behaviour is visible here instead of being an invisible library
    // default. `vertical` is included deliberately: `collision` has a whole-object default, so
    // passing only `horizontal` would replace it and drop `vertical: 'flip'`.
    //
    // Note this does NOT rescue a CSS-driven width change. Kendo positions the popup from the
    // width IT set inline; a later min-/max-width from the stylesheet does not trigger a
    // reposition, so collision cannot correct for it. That is why a width FLOOR remains risky
    // while a cap is safe.
    collision: { horizontal: 'fit', vertical: 'flip' },
};
